import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";
import { ICancelBroadbandForm } from "@features/CancelBroadband/interface/ICancelBroadbandForm";
import { useCancelBroadbandReasons } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandReasons/useCancelBroadbandReasons";
import { UseFormMethods } from "react-hook-form";
import { ControlledSelect } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandReasons/ControlledSelect/ControlledSelect";
import { useDeviceType } from "@hook/useDeviceType";
import { CancelBroadbandError } from "@features/CancelBroadband/CancelBroadbandError/CancelBroadbandError";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    cancelBroadbandForm: UseFormMethods<ICancelBroadbandForm> & Partial<UseFormMethods>;
    onSubmit: () => void;
}

export const CancelBroadbandReasons = (props: IParams) => {
    const { cancelBroadbandForm, onSubmit } = props;
    const { t } = useTranslation("cancelBroadband", { keyPrefix: "reasons" });
    const { isMobile } = useDeviceType();
    const { classes } = useStyle();
    const { primaryReasonListState, primaryReasonValue } = useCancelBroadbandReasons(cancelBroadbandForm);
    const { data: primaryReasonList, error: reasonError, isLoading: isReasonLoading } = primaryReasonListState;

    return (
        <HandleErrorAndLoading
            error={reasonError}
            errorComponent={<CancelBroadbandError />}
            hideComponentWrapper
            isLoading={isReasonLoading}
        >
            <form onSubmit={onSubmit}>
                <Stack alignItems="center" spacing={5}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Stack data-testid="cancelBroadbandForm-content" paddingX={isMobile ? 2 : 20} spacing={2}>
                                <>
                                    <Typography align="center" color="primary.contrastText" variant="h2">
                                        {t("title")}
                                    </Typography>
                                    {primaryReasonList && (
                                        <ControlledSelect
                                            cancelBroadbandForm={cancelBroadbandForm}
                                            dropdownValueList={Object.keys(primaryReasonList)}
                                            errorMessage={t("chooseOptionToContinue")}
                                            formField="primaryReason"
                                            label={t("primaryReasonLabel")}
                                            placeholder={t("primaryReasonPlaceholder")}
                                            required
                                        />
                                    )}
                                    {primaryReasonList && primaryReasonValue && (
                                        <ControlledSelect
                                            cancelBroadbandForm={cancelBroadbandForm}
                                            dropdownValueList={primaryReasonList[primaryReasonValue]}
                                            errorMessage={t("chooseOptionToContinue")}
                                            formField="secondaryReason"
                                            label={t("secondaryReasonLabel")}
                                            placeholder={t("secondaryReasonPlaceholder")}
                                            required
                                        />
                                    )}
                                </>
                            </Stack>
                        </CardContent>
                    </Card>
                    <Button color="primary" fullWidth={isMobile} size="large" type="submit" variant="contained">
                        <Typography variant="normal">{t("submitReason")}</Typography>
                    </Button>
                </Stack>
            </form>
        </HandleErrorAndLoading>
    );
};
